import { SecondaryTileCallouts } from './secondary-tile-callouts.component.js';
export { SecondaryTileCallouts } from './secondary-tile-callouts.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

/**
 * @deprecated use `SecondaryTileCallouts` component instead
 */ const SecondaryTileBadges = deprecatedComponent({
    displayName: 'SecondaryTileBadges',
    root: SecondaryTileCallouts,
    description: 'Use `SecondaryTileCallouts` component instead'
}) /* PLOP_COMPONENT_EXPORT_IN_INDEX */  // Please don't remove the above Plop token
;

export { SecondaryTileBadges };
